import { CSSObject } from '@emotion/react';
import { useHoneycombTheme } from '../../../theming';

type StyleClasses = 'panel';

export function useStyles(): {
    styles: { [key in StyleClasses]: CSSObject };
} {
    const { theme } = useHoneycombTheme();

    const { Accordion: componentTheme } = theme.components.themes;

    const panel: CSSObject = {
        padding: `0 ${componentTheme.paddingX}px ${componentTheme.contentPaddingBottom}px`,
    };

    return {
        styles: {
            panel,
        },
    };
}
